// Source: app/scripts/services/misc.js
Auction.factory('Translation', ['$resource', function ($resource) {
  return $resource('/data/rest/translations/:id', {}, {
    'insert': {
      method: 'POST',
      url: '/data/rest/translations/insert'
    },
    create: {
      method: 'GET',
      url: "/data/rest/translations/new"
    },
    paged: {
      method: 'GET',
      url: "/data/rest/translations/paged"
    }
  });
}]);
